import { useEffect, useState } from 'react'
import { api } from '../api/client.js'

export interface SuggestedArticle {
  id: string
  title: string
  snippet: string
  score: number
  category: string
  lastUpdated: string
  insertable: boolean
}

export interface UseSuggestedArticlesReturn {
  articles: SuggestedArticle[]
  loading: boolean
}

/**
 * Fetches AI-suggested knowledge base articles for a conversation from
 * GET /conversations/:id/suggested-articles. Fetches fresh per
 * `conversationId` — intentionally has no module-level cache, since a
 * cache without a per-conversation key would leak one conversation's
 * suggestions into another when an agent switches conversations.
 */
export function useSuggestedArticles(conversationId: string): UseSuggestedArticlesReturn {
  const [articles, setArticles] = useState<SuggestedArticle[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    api
      .get<{ articles: SuggestedArticle[] }>(`/conversations/${conversationId}/suggested-articles`)
      .then((response) => {
        if (!cancelled) setArticles(response.articles || [])
      })
      .catch(() => {
        if (!cancelled) setArticles([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [conversationId])

  return { articles, loading }
}
